import { useEffect, useMemo, useState } from 'react';
import useFetch from 'utils/hooks/useFetch';
import { ApiResponseStatusUnauthorized, ApiResponseSuccess, EmptyString, StatusCodeActive } from 'utils/Constant';
import { ApiGetTransferSourceList, ApiGetUserLocationByUserId, ApiLogin } from 'utils/constants/api';
import FailModal from '../components/modal/FailModal';
import LoadingModal from 'components/modal/LoadingModal';
import bg1 from 'assets/images/login_bg/bg_1.jpg';
import bg2 from 'assets/images/login_bg/bg_2.jpg';
import bg3 from 'assets/images/login_bg/bg_3.jpg';
import bg4 from 'assets/images/login_bg/bg_4.jpg';
import bg5 from 'assets/images/login_bg/bg_5.jpg';
import bg6 from 'assets/images/login_bg/bg_6.jpg';
import bg7 from 'assets/images/login_bg/bg_7.jpg';
import bg8 from 'assets/images/login_bg/bg_8.jpg';
import bg9 from 'assets/images/login_bg/bg_9.jpg';
import bg10 from 'assets/images/login_bg/bg_10.jpg';

const imageList = [bg1, bg2, bg3, bg4, bg5, bg6, bg7, bg8, bg9, bg10];

export default function Login() {
	const { fetch: login } = useFetch(ApiLogin)
	const { fetch: apiGetUserLocationByUserId } = useFetch(ApiGetUserLocationByUserId)
    const { fetch: apiGetTransferSourceList } = useFetch(ApiGetTransferSourceList)

	const [username, setUsername] = useState(EmptyString)
	const [password, setPassword] = useState(EmptyString)
	const [loginMessage, setLoginMessage] = useState()
	const [isLoginButtonDisabled, setIsLoginButtonDisabled] = useState(true)
	const [isShowPassword, setIsShowPassword] = useState(false)

	const [failModal, setFailModal] = useState({ isOpen: false, data: {}, message: EmptyString })
	const [loading, setLoading] = useState({ isOpen: false })

	const randomImage = useMemo(() => {
		const index = Math.floor(Math.random() * imageList.length);
		return imageList[index];
	}, []);

	useEffect(() => {
		if(username !== EmptyString && password !== EmptyString){
			setIsLoginButtonDisabled(false)
		}else{
			setIsLoginButtonDisabled(true)
		}
	}, [username, password])

	async function fLogin(){
		let userId = ''

		await login({
			data: {
				username: username,
				password: password
			}
		}).then((response) => {
			if(response !== null){
				if(response.status === ApiResponseSuccess){
					if(response.message !== EmptyString){
						setLoginMessage(response.message)
					}else{
						let data = response.data

						localStorage.setItem("UserId", data.userId)
						localStorage.setItem("Username", data.username)
						localStorage.setItem("FullName", data.fullName)
						localStorage.setItem("Token", data.token)
						localStorage.setItem("IsAdmin", data.isAdmin === true ? "1" : "0")
						
						userId = data.userId
					}
				}else{
					setFailModal({
						isOpen: true,
						data: {
							onSuccess: async () => {
								setFailModal({isOpen: false})
							}
						},
						message: response.message
					})
				}
			}else{
				setFailModal({
					isOpen: true,
					data: {
						onSuccess: async () => {
							setFailModal({isOpen: false})
						}
					},
					message: "Server error"
				})
			}
		})

		return userId
	}
	const getUserLocationAccessList = async(id) => {
		await apiGetUserLocationByUserId({
			data: {
				userId: id
			}
		}).then((response) => {
			if(response.status === ApiResponseSuccess){
				let locationOptions = response.data.map((item) => {
					return { value: String(item.locationId), label: item.locationName.toUpperCase() }
				})

				localStorage.setItem("UserLocation", JSON.stringify(locationOptions))
			}else if(response.status === ApiResponseStatusUnauthorized){
				setFailModal({
					isOpen: true,
					data: {
						onSuccess: async () => {
							setFailModal({isOpen: false})
							window.location.href = "/login"
						}
					},
					message: response.message
				})
			}else{
				setFailModal({
					isOpen: true,
					data: {
						onSuccess: async () => {
							setFailModal({isOpen: false})
						}
					},
					message: response.message
				})
			}
		})
	}
	const getTransferSourceList = async () => {
		await apiGetTransferSourceList({
			data: {
				bankId: EmptyString,
				sourceName: EmptyString,
				status: StatusCodeActive,
				pageSize: 100,
				pageIndex: 0
			}
		}).then((response) => {
			if(response.status === ApiResponseSuccess){
				let transferSourceOptions = response.data.listData.map((item) => {
					return { value: String(item.transferSourceId), label: item.sourceName.toUpperCase() + " (" + item.accountNo + ")" }
				})

				// transferSourceOptions = transferSourceOptions.push({ value: "0", label: ""})

				localStorage.setItem("TransferSource", JSON.stringify(transferSourceOptions))
			}else if(response.status === ApiResponseStatusUnauthorized){
				setFailModal({
					isOpen: true,
					data: {
						onSuccess: async () => {
							setFailModal({isOpen: false})
							window.location.href = "/login"
						}
					},
					message: response.message
				})
			}else{
				setFailModal({
					isOpen: true,
					data: {
						onSuccess: async () => {
							setFailModal({isOpen: false})
						}
					},
					message: response.message
				})
			}
		})
	}

	function fEnterKeyDown(e){
		if(e.key === 'Enter'){
			fLoginBtnClick()
		}
	}

	function fLoginBtnClick(){
		setLoading({ isOpen: true })

		// Perform validation

		if(!validation()){
			setLoading({ isOpen: false })
			return
		}
		
		// Perform login

		fLogin().then((res) => {
			if (res === '') {
				setLoading({ isOpen: false })
				return
			}
			
			getUserLocationAccessList(res).then(() => {
				getTransferSourceList().then(() =>  {
					window.location.assign('/')
					setLoading({ isOpen: false })
				})	
			})			
		})
	}

	const validation = () => {
		let isValid = true
	
		if (username === EmptyString) {
			isValid = false
			setLoginMessage("Please enter username")
		} else if (password === EmptyString) {
			isValid = false
			setLoginMessage("Please enter password")
		} else {
			setLoginMessage(EmptyString)
		}

		return isValid
	}

	return (
		<div className="w-full h-screen fixed overflow-hidden flex flex-col justify-center items-center gap-8 bg-cover bg-center"
			style={{ backgroundImage: `url(${randomImage})` }}
		>
			<div className='shadow-md rounded-lg py-16 px-6 sm:px-12 bg-white/60 backdrop-blur-sm'>
				{/* Login title */}
				<div className='flex flex-col gap-4 items-center'>
					<span className='text-3xl md:text-5xl font-semibold'>Yupiter</span>
					{/* <span className='text-xl md:text-xl font-semibold'>Yupiter</span> */}
					<span className='text-2xl'>Login</span>
				</div>

				{/* Login form */}
				<div className='flex flex-col bg-blue w-80 gap-4 mt-8'>
					<div>
						{/* <h1 className=''>Username</h1> */}
						<input 
							className='seq-input focus:outline-none focus:ring-0 focus:border-transparent border border-gray-300 !rounded-full'
							value={username} 
							onChange={(e) => {setUsername(e.target.value)}} onKeyDown={(e) => { fEnterKeyDown(e) }} 
							placeholder='Username'
						/>
					</div>
					
					<div>
						{/* <h1 className=''>Password</h1> */}
						<input 
							className='seq-input focus:outline-none focus:ring-0 focus:border-transparent border border-gray-300 !rounded-full' 
							value={password} 
							onChange={(e) => {setPassword(e.target.value)}} onKeyDown={(e) => { fEnterKeyDown(e) }} 
							type={isShowPassword ? 'text' : 'password'} 
							placeholder='Password'
						/>
					</div>

					<div className='flex items-center gap-2'>
						<input className='w-4' value={isShowPassword} checked={isShowPassword} onClick={() => { setIsShowPassword(!isShowPassword) }} type='checkbox' />
						<span>Show password</span>
					</div>

					<div>
						<span className='text-red-500'>{loginMessage}</span>
					</div>

					<button className={`login-button bg-black mt-4 !rounded-full`} onClick={() => {fLoginBtnClick()}} >
						Login
					</button>
				</div>
			</div>
			

			{/* Modal */}
			{failModal.isOpen && (
                <FailModal onClose={() => setFailModal({ isOpen: false, data: {}, message: EmptyString })} data={failModal?.data} message={failModal?.message} />
            )}
			{loading.isOpen && (<LoadingModal onClose={() => setLoading({ isOpen: false })} />)}
		</div>
	);
}
